import 'magnific-popup';
import Cookies from 'js-cookie';

const getPopupCookie = Cookies.get('newsletter_popup');

if (!getPopupCookie) {
	setTimeout(() => {
		$.magnificPopup.open({
			items: {
				src: $('#popup-newsletter'),
			},
			type: 'inline',
			fixedBgPos: false,
			fixedContentPos: false,
			mainClass: 'mfp-newsletter',
			callbacks: {
				open: function () {
					Cookies.set('newsletter_popup', 'is-active', { expires: 7 });
				},
			},
		});
	}, 10000);
}

$(document).on('click', '.js-close-popup', function (e) {
	e.preventDefault();
	$('.mfp-close').trigger('click');
});
